<template>
    <div>
        <modal v-model="openForm" footer-hide :title="item.no" fullscreen ref="formModel">
            <iframe name="print" ref="iframe" :src="item.src" id="printPdf" frameborder="0"></iframe>


        </modal>
    </div>
</template>
<script>
import fields from "./fields";
export default {
    data() {
        return {
            openForm: false,
            item: {}
        };
    },
    methods: {
        reach(v) {
            this.item = v;
            //window.open(this.item.src);
            this.openForm = true;
            //window["videoFrame" + i].window.stop(v);
        },

    },
};
</script>
<style>
#printPdf {
    width: 100%;
    height: calc(100% - 0px);
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwufeiyong/PrintPdf.vue